<template>
  <div>
    <MenuItem name="home" to="/main/"><Icon type="ios-stats" />{{ $t('menu.home') }}</MenuItem>
    <MenuItem name="log" to="/main/log"><Icon type="logo-buffer" />{{ $t('menu.log') }}</MenuItem>
    <MenuItem name="bill" to="/main/bill">
      <Icon type="md-bookmark" />{{ $t('menu.bill') }}
      <div class="scoped-right">
        <Badge v-if="user_bill" :count="user_bill.post.count" type="warning"></Badge>
      </div>
    </MenuItem>
    <MenuItem name="ticket" to="/main/ticket"><Icon type="md-bookmarks" />{{ $t('menu.ticket') }}</MenuItem>
    <MenuItem name="address" to="/main/address"><Icon type="md-filing" />{{ $t('menu.address') }}</MenuItem>
    <MenuGroup :title="$t('menu.cex_menu')">
      <MenuItem name="cex" to="/main/cex" >
        <Icon type="md-jet" />{{ $t('menu.cex') }}
        <div class="scoped-right">
          <Badge v-if="cex_order" :count="cex_order.count" type="primary"></Badge>
        </div>
      </MenuItem>
      <MenuItem name="cex-order" to="/main/cex/order">
        <Icon type="md-list-box" />{{ $t('menu.cex_order') }}
        <div class="scoped-right">
          <Badge v-if="cex_order_breakdown" :count="cex_order_breakdown.count" type="error"></Badge>
        </div>
      </MenuItem>
      <MenuItem name="cex-take" to="/main/cex/take"><Icon type="md-notifications" />{{ $t('menu.cex_take') }}</MenuItem>
    </MenuGroup>
  </div>
</template>
<script>
import { userBill, cexOrderPay, cexOrderBreakdown } from '@/api/total'

export default {
  props: {
    update: Function
  },
  data() {
    return {
      user_bill: null,
      cex_order: null,
      cex_order_breakdown: null
    }  
  },
  created() {
    this.getData()
    this.getTask()
    
    // 定时更新
    setInterval(this.getTask, 10000);
  },
  methods:{
    getData() {
      // 帐单
      userBill().then(res => {
        this.user_bill = res
      })
    },
    
    // 定时任务
    getTask()
    {
      // 预备单数量
      cexOrderPay().then(res => {
        this.cex_order = res
      })
      
      // 故障订单
      cexOrderBreakdown().then(res => {
        this.cex_order_breakdown = res
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .scoped-right{
    float:right;
    
    &.x{
      margin-right: 15px
    }

    &.m{
      margin-right: 25px
    }
  }

</style>